// https://swiperjs.com/get-started
import SwiperCore, { Navigation, Pagination, Scrollbar, Thumbs, EffectFade, Autoplay, Controller } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Scrollbar, Thumbs, EffectFade, Autoplay, Controller]);
import 'swiper/swiper-bundle.css';

// const swiper = new SwiperCore('.swiper-container', {
//     // Optional parameters
//     direction: 'horizontal',
//     loop: true,
//     // slidesPerView: 6,

//     // If we need pagination
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true
//     },

//     // Navigation arrows
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },

//     // And if we need scrollbar
//     scrollbar: {
//         el: '.swiper-scrollbar',
//     },
// });



// const swiperResult = new SwiperCore('.swiper-results', {
//     direction: 'horizontal',
//     loop: false,
//     slidesPerView: 1,
//     // spaceBetween: 20,
//       pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//         dynamicBullets: true,
//         dynamicMainBullets: 2
//     },
//     slideToClickedSlide: true,
// });
document.querySelectorAll('.swiper-results').forEach((swiperElement) => {
  const swiperWrapper = swiperElement.closest('.swiper--results--wrap'); // Finde den spezifischen Parent
  const paginationElement = swiperWrapper.querySelector('.swiper-pagination'); // Finde die zugehörige Pagination

  new SwiperCore(swiperElement, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      pagination: {
          el: paginationElement, // Setze die spezifische Pagination
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 2
      },
      slideToClickedSlide: true,
  });
});


const swiperLeft = new SwiperCore('.left--align--slider', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 20,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        slidesPerView: 2.2,
      }
    }
});

const swiperCenter = new SwiperCore('.center--align--slider', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 20,
    slideToClickedSlide: true,
    centeredSlides: true,
    breakpoints: {
      768: {
        slidesPerView: 2.2,
        centeredSlides: false,
      }
    }
});


var swiperThumbBottom = new SwiperCore(".slider--thumb--bottom", {
    spaceBetween: 20,
    loop: false,
    slidesPerView: 1.2,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slideToClickedSlide: true,
  });
  var swiperThumbTop = new SwiperCore(".slider--thumb--top", {
    effect: 'fade',
  });





$(document).ready(function(){
  swiperThumbTop.controller.control = swiperThumbBottom;
  swiperThumbBottom.controller.control = swiperThumbTop;


  setTimeout(function(){
    const swiperAuto = new SwiperCore('.auto--logo--slider', {
      // modules: [Autoplay],
        direction: 'horizontal',
        loop: true,
        slidesPerView: 3.5,
        spaceBetween: 40,
        speed: 3000,
        // slideToClickedSlide: true,
        // watchSlidesVisibility: true,
        pauseOnMouseEnter: false,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        observer: true,
        breakpoints: {
          640: {
            slidesPerView: 4.5,
          },
          768: {
            slidesPerView: 5.5,
          }
        },
    
        // on: {
        //   afterInit: function() {
        //   // console.log('afterInit', swiper);
        //   setTimeout(function(){
        //     window.dispatchEvent(new Event('resize'));
        //     // swiperAuto.autoplay.pause();
        //     swiperAuto.autoplay.start();
        //     // swiper.autoplay.start();
        //     console.log(swiperAuto.autoplay);
        //   }, 5000);
        //   }
        // },
        // freeMode: true,
    });

}, 750);


  // swiperAuto.autoplay.start();
  // swiperAuto.autoplay.stop();
  

        //   setTimeout(function(){
        //   window.dispatchEvent(new Event('resize'));
        //   console.log(swiperAuto.autoplay);
        //   swiperAuto.autoplay.pause();
        //   swiperAuto.autoplay.resume()
        // }, 5000);

  // console.log(swiperAuto);

})